<template>
    <div>
      <el-button @click="() => onGoBackList(false)">取消</el-button>
      <el-button v-if="active" type="primary" @click="handleEmit('onPrev')"
        >上一步</el-button
      >
      <el-button
        v-if="active !== stepsList.length - 1"
        type="primary"
        @click="handleEmit('onNext')"
        >下一步</el-button
      >
      <el-button
        v-if="active == stepsList.length - 1 && !isDisabled"
        :disabled="disabled"
        type="primary"
        @click="onSave"
      >
        保存
      </el-button>
  </div>
</template>

<script>
import { saveAuditOwner } from '@/api/approvalApi'
import mixin from '../../../mixins/auditFlowManage'

export default {
  name: 'approveFooter',
  mixins: [mixin],
  data() {
    return {
      disabled: false,
    }
  },
  props: ['active', 'isDisabled'],
  methods: {
    handleEmit(type, val) {
      this.$emit(type, val)
    },
    // onNext () {
    //   this.active += 1
    // },
    // onPrev () {
    //   this.active -= 1
    // },
    // 校验审批人场景
    validAudit(flowList) {
      let message = ''
      // flag校验异常情况标识
      let flag = false
      // flowList:审批流配置,actionType: 4抄送人
      if (flowList && Array.isArray(flowList) && flowList.length) {
        // 过滤出审批人数据
        const filterFlowList = flowList.filter((item) => item.actionType !== 4)
        if (!filterFlowList.length) {
          message = '请至少添加一个审批人'
          flag = true
        }
        const userIds = []
        filterFlowList.forEach((item) =>
          item.approverInfosList.forEach((userId) => userIds.push(userId)))
        // const uniqUserIds = [...new Set(userIds)]
        // if (uniqUserIds.length !== userIds.length) {
        //   message = '审批人不可重复'
        //   flag = true
        // }
      } else {
        message = '请至少添加一个审批人'
        flag = true
      }
      return { flag, message }
    },
    onGoBackList(flag = false) {
      this.$refreshBack(flag) // 关闭当前tab, flag为true时刷新页面
    },
    // 保存
    async onSave() {
      if (this.disabled) return
      this.disabled = true
      try {
        // eslint-disable-next-line vue/no-mutating-props
        this.active = 1
        const { id, flowList } = this.auditDetail
        const validateAudit = this.validAudit(flowList)
        const { flag, message } = validateAudit
        if (flag) {
          this.$message.error(message)
          return
        }
        const paramsList = flowList.map((item) => {
          const tempFlow = {}
          // actionType:4 抄送类型
          if (Number(item.actionType) === 4) {
            tempFlow.ccList = item.approverInfosList
          } else {
            tempFlow.approverList = item.approverInfosList
            let temp = 'OR'
            if (item.actionType === 1) {
              temp = 'NONE'
            } else if (item.actionType === 2) {
              temp = 'AND'
            }
            tempFlow.actionType = temp
          }
          tempFlow.level = item.nodeIndex + 1
          return tempFlow
        })

        const submitParams = {
          id,
          flowList: paramsList,
        }
        console.log('submitParams', submitParams)
        const res = await saveAuditOwner(submitParams)
        const { code } = res
        if (code === 1) {
          this.$message('保存成功')
          this.onGoBackList(true)
        }
      } finally {
        this.disabled = false
      }
    },
  },
}
</script>

<style>

</style>
